import { Component, OnChanges, SimpleChanges, inject, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { DetailedQuote } from '../../../../domain/quote.domain';
import { HrefDirective } from '../../../../directives/href/href.directive';
import { LinkRegistryService } from '../../../../services/link-registry.service';
import { QuoteConstants, QuoteLinks } from '../quote.constants';

export interface QuoteLink extends QuoteLinks {
  url?: string;
}

export type QuoteLinkParams = Pick<DetailedQuote, 'issueType' | 'symbol' | 'country' | 'underlyingSymbol' | 'issueId'>;

@Component({
  selector: 'td-wb-quote-link',
  templateUrl: 'quote-link.component.html',
  styleUrls: ['quote-link.component.scss'],
  imports: [
    HrefDirective,
    TranslateDirective
  ]
})
export class QuoteLinkComponent implements OnChanges {
  private readonly linkRegistryService = inject(LinkRegistryService);

  readonly quote = input<QuoteLinkParams>(undefined);

  links: Array<QuoteLink>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.quote !== undefined) {
      this.links = this.getLinks();
    }
  }

  private getLinks(): Array<QuoteLink> {
    let linksUrl = [];
    const quote = this.quote();
    if (quote !== undefined && quote.issueType !== undefined) {
      linksUrl = QuoteConstants.getQuoteLinks(quote.issueType);
      for (const link of linksUrl) {
        link.url = this.getLinkUrl(link);
      }
    }
    return linksUrl;
  }

  private getLinkUrl(link: QuoteLink): string {
    let symbol = this.quote().symbol;
    const quote = this.quote();
    if (quote[link.symbolFrom] !== undefined) {
      symbol = quote[link.symbolFrom];
    }
    if (link.symbolFrom === 'issueId') {
      return this.linkRegistryService.getLink(link.link) + (symbol === undefined ? '' : ('%2F' + symbol));
    }
    return this.linkRegistryService.getLink(link.link) +
      (quote.country === undefined ? '' : ('%2F' + quote.country)) + (symbol === undefined ? '' : ('%2F' + symbol));
  }
}
